import { defineComponent as r, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as h } from "vue";
const f = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "0e1a148b-cab5-49b2-8da6-9ec505ed2859" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#0e1a148b-cab5-49b2-8da6-9ec505ed2859)" }, v = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 155.8 255-30.6 257 30.6v33.4l-27.7 67.2 27.7 66.4v33.4l-256 32.4L0 356.2v-33.4l28.8-68.5L0 189.2z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#a2001d",
  d: "M0 0h512v155.8H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 189.2h512v133.6H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 356.2h512V512H0z"
}, null, -1), b = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ r({
  __name: "gm",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), c("title", v, d(t.flagName), 1)) : _("", !0),
        p,
        k,
        g,
        x
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=gm-db366708.js.map
